<template>
	<section class="page page-styleguide">
		<section id="typography">
			<h1>Heading #1</h1>
			<h2>Heading #2</h2>
			<h3>Heading #3</h3>
			<h4>Heading #4</h4>
			<h5>Heading #5</h5>
			<h6>Heading #6</h6>
		</section>

		<ViewUiButtonBack />

		<ViewUiButtonBackArrow />

		<ViewUiButtonContinue />

		<ViewUiButtonGetStarted />

		<ViewUiButtonLogin />

		<ViewUiButtonReady />

		<ViewUiButtonSignUp />

		<ViewUiButtonSkip />
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageStyleguide extends PageBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.page-styleguide {
		// Not implemented
	}
</style>
